<template>
  <header role="banner" class="header" aria-label="Top Banner">
    <nav id="header" class="alt mc-header" aria-label="Main Navigation">
      <div id="logo">
        <a href="/"><img v-bind:src="'/img/brand/' + brand" alt="Logo" width="175" /></a>
      </div>
      <menu-bar name="Logo Name" :navLinks="data" />
      <div v-on:click="openMobileNav()" id="burger">
        <div class="line1"></div>
        <div class="line2"></div>
        <div class="line3"></div>
      </div>
    </nav>
  </header>
</template>

<script>
import MenuBar from "../atoms/MenuBar";
export default { 
  name: "SiteHeader", 
  props: ["brand", 'data'],
  components: {
      MenuBar,
  },
  methods: {
    openMobileNav() {
      const burger = document.getElementById("burger");
      const nav = document.querySelector(".nav-links");
      const navLinks = document.querySelectorAll(".nav-links li");
      // Toggle navigation on mobile
      nav.classList.toggle("nav-active");
      // Burger toggler
      burger.classList.toggle("toggle");
      // Animate navigation links
      navLinks.forEach((link, index) => {
        if (link.style.animation || link.style.webkitAnimation) {
          link.style.animation = "";
          link.style.webkitAnimation = "";
        } else {
          link.style.webkitAnimation = `navLinkFade 0.5s ease forwards ${index / 7}s`;
          link.style.animation = `navLinkFade 0.5s ease forwards ${index / 7}s`;
        }
      });
    },
  },
};
</script>
